module.exports = __webpack_public_path__ + "static/img/bg17.b1ec0be8.png";